import React, { useEffect, useState } from "react";
import "../assets/css/Panel.css";
import Navbar from "../components/Navbar";
import {api} from "../utils/gashtaltAPI";
import ErrorPage from "../components/ErrorPage";
import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import { toPersianNumber } from "../utils/numberConversion";
import { toast } from "react-toastify";
import FilterTd from "../components/FilterTd";
import { RiFileExcel2Line } from "react-icons/ri";
import DownloadHandler from "../utils/downloadHandler";
import {useDispatch} from "react-redux";
import Loader from "../components/Loader";

function Users() {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState(null);
  const {
    isOpen: nameOpen,
    onToggle: nameToggle,
    onClose: nameClose,
  } = useDisclosure();
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [startIndex, setStartIndex] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const dispatch = useDispatch();
  const [loading,setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/api/users?page=${currentPage}`, {
          params: filters,
        });
        setUsers(response.data.data);
        setCurrentPage(response.data.current_page);
        setStartIndex(response.data.from);
        setLastPage(response.data.last_page);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [currentPage, filters]);

  const handleNextPage = () => {
    if (currentPage < lastPage) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };
  const changeRole = async (userId) => {
    dispatch(setLoading(true))
    try {
      const response = await api.post("/api/users/updateRole", {
        user_id: userId,
      });
      setUsers((prevUsers) =>
        prevUsers.map((user, i) => ({
          ...user,
          role: user.id === userId ? response.data.role : user.role,
        }))
      );
      toast.success(response.data.message, {
        position: "bottom-right",
      });
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status !== 500) {
          toast.error(error.response.data.message, {
            position: "bottom-right",
          });
        }
        return;
      } else if (error.request) {
        toast.error("اتصال اینترنت خود را بررسی کنید!", {
          position: "bottom-right",
        });
        return;
      }
      toast.error("خطایی رخ داد!", {
        position: "bottom-right",
      });
    }finally {
      dispatch(setLoading(false))
    }
  };
  const toggleStatus = async (userId) => {
    dispatch(setLoading(true))
    try {
      const response = await api.post("/api/users/updateStatus", {
        user_id: userId,
      });
      setUsers((prevUsers) =>
        prevUsers.map((user, i) => ({
          ...user,
          active: user.id === userId ? response.data.active : user.active,
        }))
      );
      toast.success(response.data.message, {
        position: "bottom-right",
      });
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status !== 500) {
          toast.error(error.response.data.message, {
            position: "bottom-right",
          });
        }
        return;
      } else if (error.request) {
        toast.error("اتصال اینترنت خود را بررسی کنید!", {
          position: "bottom-right",
        });
        return;
      }
      toast.error("خطایی رخ داد!", {
        position: "bottom-right",
      });
    }finally {
      dispatch(setLoading(false))
    }
  };

  if (loading) return <Loader />
  if (error) return <ErrorPage error={error} />;
  return (
    <div className="d-flex flex-column h-100">
      <Navbar />
      <div
        className="table-container flex-fill d-flex flex-column justify-content-between"
        style={{ borderTop: "3px solid #EAEAEA" }}
      >
        <TableContainer>
          <Table variant="striped" colorScheme="teal">
            <Thead>
              <Tr>
                <Td>ردیف</Td>
                <Td>
                  <FilterTd
                    name={"نام و نام خانوادگی"}
                    defaultValue={filters.name}
                    onSubmit={(value) => {
                      setCurrentPage(1);
                      setFilters((prevFilters) => ({
                        ...prevFilters,
                        name: value,
                      }));
                    }}
                    onCancel={() => {
                      setCurrentPage(1);
                      setFilters((prevFilters) => {
                        const { name, ...rest } = prevFilters;
                        return rest;
                      });
                    }}
                  />
                </Td>
                <Td>
                  <FilterTd
                    name={"شماره همراه"}
                    defaultValue={filters.phone_number}
                    onSubmit={(value) => {
                      setCurrentPage(1);
                      setFilters((prevFilters) => ({
                        ...prevFilters,
                        phone_number: value,
                      }));
                    }}
                    onCancel={() => {
                      setCurrentPage(1);
                      setFilters((prevFilters) => {
                        const { phone_number, ...rest } = prevFilters;
                        return rest;
                      });
                    }}
                  />
                </Td>
                <Td>نقش</Td>
                <Td>وضعیت</Td>
              </Tr>
            </Thead>
            <Tbody>
              {users.map((user, index) => (
                <Tr>
                  <Td>{toPersianNumber(startIndex+index)}</Td>
                  <Td>{user.name}</Td>
                  <Td>{user.phone_number}</Td>
                  <Td>
                    <button
                      className={`btn ${
                        user.role === 0
                          ? "btn-outline-blue"
                          : "btn-outline-green"
                      }`}
                      onClick={() => {
                        changeRole(user.id);
                      }}
                    >
                      {user.role === 0 ? "کاربر" : "مدیر"}
                    </button>
                  </Td>
                  <Td>
                    <button
                      className={`btn ${
                        user.active ? "btn-outline-green" : "btn-outline-red"
                      }`}
                      onClick={() => {
                        toggleStatus(user.id);
                      }}
                    >
                      {user.active ? "فعال" : "غیرفعال"}
                    </button>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
        <div className="py-2 d-flex justify-content-center gap-3">
          <button
              className={`btn btn-outline-orange`}
              disabled={1 === currentPage}
              onClick={() => {
                setCurrentPage(1)
              }}
          >
            صفحه اول
          </button>
          <button
              className={`btn btn-outline-blue`}
              disabled={currentPage === 1}
              onClick={handlePrevPage}
          >
            صفحه قبل
          </button>
          <button
              className={`btn btn-outline-blue`}
              disabled={lastPage === currentPage}
              onClick={handleNextPage}
          >
            صفحه بعد
          </button>
          <button
              className={`btn btn-outline-orange`}
              disabled={lastPage === currentPage}
              onClick={() => {
                setCurrentPage(lastPage)
              }}
          >
            صفحه آخر
          </button>
          <button
              className={`btn btn-outline-green d-flex align-items-center gap-1`}
              disabled={lastPage === currentPage}
              onClick={() => {
                DownloadHandler()
              }}
          >
            <RiFileExcel2Line style={{fontSize:'1.1rem'}}/>
            خروجی اکسل
          </button>
        </div>
      </div>
      <div></div>
    </div>
  );
}

export default Users;
